/**
 * Aviso curto ("Plano salvo ✓") que some sozinho — o toast das telas do Plano de
 * Ação. Um aviso novo substitui o anterior e reinicia o tempo.
 */
import { useCallback, useEffect, useRef, useState } from "react";

const DURACAO_MS = 2600;

export function useAviso(): { aviso: string | null; notificar: (msg: string) => void } {
  const [aviso, setAviso] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const notificar = useCallback((msg: string) => {
    setAviso(msg);
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => setAviso(null), DURACAO_MS);
  }, []);
  useEffect(
    () => () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    },
    [],
  );
  return { aviso, notificar };
}
